import React from 'react';
import {
  histologicalTumorTypeCaseLevelFieldsData,
  histologicalGradeFieldsData,
  tumourExtentFieldsData,
  presentStatusFieldsData,
  termsOfAgreementFieldData,

} from './caseAndSpecimenAnalysisFieldsData';
import {
  histologicalTumorTypeJSX,
  histololicalGradeJSX,
  tumourExtentJSX,
  presentStatusCollectionJSX,
  termsAgreementJSX,
  regularSaveButtonJSX,
  reopenAnalysisButtonJSX,
  submitAnalysisButtonJSX,
  submitAnalysisAndGoToNextButtonJSX,
  submitAllAnalyzesButtonDemoJSX,
  saveAllAnalyzes,
} from './caseAndSpecimenAnalysisFieldsJSX';
import PersonalInformationForm from '../personalInformationForm/PersonalInformationForm';



import FormHeader from '../shared/FormHeader';
import { userRoles } from '../../constants';



const CaseAnalysisComponent = ({
  getFieldValue,
  numberOfCores,
  userRole,
  analysisMarkedAsDone,
  pristine,
  submitting,
  handleMarkAsDone,
  handleSaveAndGoToNext,
  invalid,
  setFieldValue,
  containsUnsavedChanges,
  submitAllButtonProps,
  handleSubmitAllDemo,
  pathologistName,
  saveAllUnsavedSpecimenAnalyzes,
  markAnalyzeesDoneWarningText,
  disableSaveAllButton,
  goBackToStatusAwaitingAnalysis,
  caseIsSubmittedDemo,
  formShouldBeDisabled,
}) => {
  const titleRow1 = 'Prostate Core Needle Biopsy Histopathology Report';
  const titleRow2 = (userRole !== userRoles.val_pathologist ? 'Part 2 - Case Level' : 'Case Level');

  let filteredFieldsData = [
    ...histologicalTumorTypeCaseLevelFieldsData,
    ...histologicalGradeFieldsData,
    ...tumourExtentFieldsData,
    ...presentStatusFieldsData,
    termsOfAgreementFieldData,
  ];

  const toExcludeFields = [];
  if (userRole === userRoles.val_pathologist) {
    toExcludeFields.push('percentageGleasonPattern', 'specifyGleasonPatternPercentage');
  }


  if (toExcludeFields.length > 0) {
    filteredFieldsData = filteredFieldsData.filter(field => !toExcludeFields.includes(field.name));
  }
  return (
    <>
      <FormHeader titleRow1={titleRow1} titleRow2={titleRow2} />
      <div className="side side-left">
        <fieldset
          className="side-content"
          disabled={formShouldBeDisabled}
        >
          {histologicalTumorTypeJSX(filteredFieldsData, getFieldValue)}
          {histololicalGradeJSX(filteredFieldsData, getFieldValue, setFieldValue)}
          {tumourExtentJSX(filteredFieldsData, numberOfCores, setFieldValue)}
        </fieldset>
      </div>
      <div className="side side-right">
        <fieldset
          className="side-content"
          disabled={formShouldBeDisabled}
        >
          {presentStatusCollectionJSX(filteredFieldsData, getFieldValue, setFieldValue)}

          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            {termsAgreementJSX(termsOfAgreementFieldData, pathologistName)}
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '26px' }}>
            {((userRole === userRoles.pathologist || userRole === userRoles.admin) && !caseIsSubmittedDemo) && saveAllAnalyzes(saveAllUnsavedSpecimenAnalyzes, disableSaveAllButton)}
          </div>
        </fieldset>
        {(userRole === userRoles.pathologist || userRole === userRoles.admin) && (
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            {caseIsSubmittedDemo
              ? reopenAnalysisButtonJSX(goBackToStatusAwaitingAnalysis)
              : submitAllAnalyzesButtonDemoJSX(handleSubmitAllDemo, submitAllButtonProps, markAnalyzeesDoneWarningText)}
          </div>
        )}

        {(userRole === userRoles.val_pathologist) && (
          <>
            {!analysisMarkedAsDone && submitAnalysisButtonJSX(handleMarkAsDone, submitting)}
            {analysisMarkedAsDone && reopenAnalysisButtonJSX(goBackToStatusAwaitingAnalysis)}
            {!analysisMarkedAsDone && submitAnalysisAndGoToNextButtonJSX(handleSaveAndGoToNext, submitting)}
          </>
        )}
      </div>
    </>
  );
};

export default CaseAnalysisComponent;
